// eslint-disable-next-line import/prefer-default-export
export const enableAllValidationTriggers = (validationRules) => {
  Object.values(validationRules).forEach((values) => {
    values.forEach((rule) => {
      // eslint-disable-next-line no-param-reassign
      rule.trigger = ['change', 'blur'];
    });
  });
};
